import { httpClient } from 'app/api/http/http-client';
import { useMutation } from 'react-query';
// import { RequisiteRequestType, RequisiteResponseType } from 'app/utils/services/types/requisite.type';

const refreshToken = localStorage.getItem('refreshToken');

const extractService = {
  getExtract: async (data: any, path: any): Promise<any> => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/get-account-statements', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = path;
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
  getAction: async (data: any, path: any): Promise<any> => {
    try {
      const result = await httpClient.post<any>(
        `/api-web/v1/main/get-account-statements?business_key=${data.url}`,
        data.data
      );

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = path;
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
};

export const useExtractService = (path: any) => {
  const {
    isLoading: isLoadingExtract,
    data: dataExtract,
    mutate: extractMutation,
  } = useMutation(['extract'], (data: any) => extractService.getExtract(data, path), {});

  return { isLoadingExtract, dataExtract, extractMutation };
};

export const useExtractActionService = (path: any) => {
  const {
    isLoading: isLoadingExtractActions,
    isSuccess: isSuccessExtractActions,
    data: dataExtractActions,
    mutate: extractActionsMutation,
  } = useMutation(['extractActions'], (data: { data: any; url: string }) => extractService.getAction(data, path), {});

  return { isLoadingExtractActions, isSuccessExtractActions, dataExtractActions, extractActionsMutation };
};
